import * as SSO from "@10x/sso";
import { setUser } from "@10x/sso";
import { TabuProfile, TabuVIPCategory } from "@10x/sso/TabuProfile";
import Actions from "@my-dld/actions";
import { dispatch } from "./StoreUtils";
import { SSOProfile } from "@10x/sso/SSOProfile";
import { Profile } from "@10x/dubai-rest-api/dist/identity/entity";
import { IdentityApi } from "@10x/dubai-rest-api";
import { getAppServices } from "@10x/coreapp";

export function setTabuUser( data: any ) {
	const user = SSO.createUser( TabuProfile, getAppServices().storeService.getStore().getState().User.RequiredUserVersion, data );
	setUser( user );
}

export function setSSOUser( data: any ) {
	const user = SSO.createUser( SSOProfile, getAppServices().storeService.getStore().getState().User.RequiredUserVersion, data );
	setUser( user );
}

export function getUser() {
	return SSO.getUser();
}


export function setToken( token?: string ) {
	dispatch( Actions.TOKEN_CHANGED, token );
}

export function getToken() {
	return getAppServices().storeService.getStore().getState().User.token;
}

export function getGuestToken() {
	return getAppServices().storeService.getStore().getState().User.guestToken;
}

export function setGuestToken( token?: string ) {
	dispatch( Actions.GUEST_TOKEN_CHANGED, token );
}

export function refreshTabuProfile( onProfile?: ( profile: Profile ) => void, onError?: ( error: any ) => void ) {
	IdentityApi.me().then( profile => {
		try {
			if ( onProfile ) onProfile( profile.response?.profile );
		} catch ( e ) {

		}
	} ).catch( e => {
		if ( onError ) onError( e );
	} );
}

export function getVIPCategory(): TabuVIPCategory | undefined {
	return getAppServices().storeService.getStore().getState().User.vipCategory;
}


export function isEmailVerified(): boolean {
	return true;
	//let profile = TabuProfile.getProfile();
	//return !(profile && !profile.isEmailVerified);
}
